module.exports = __webpack_public_path__ + "assets/HKNova-ExtraBold.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-ExtraBold.ttf
// module id = 120
// module chunks = 0